

// text to show for the clinical cases notification
export const messageText = '¡Atención! elegiste un nuevo caso clínico.';
export const description = `Hay una edición en curso en el actual  caso clínico. 
Si das click en continuar sin antes GUARDAR LOS CAMBIOS, se perderá cualquier modificación hecha.`;


export const newCaseTextMessage = 'Atención elegiste crear un nuevo caso clínico.';
export const newCaseDescriptionMessage = `Hay una edición en curso en el actual  caso clínico. 
Si das click en continuar sin antes GUARDAR LOS CAMBIOS, se perderá cualquier modificación hecha.`;

export const showFiltersTextMessage = `Atención elegiste ver los filtros.`
export const showFiltersDescriptionMessage = `Tienes un caso clínico seleccionado, 
recomendamos guardar cualquier cambio hecho antes de aplicar algún filtro 
ya que al aplicar los filtros el caso clínico seleccionado actualmente se ocultará.`

export const caseTemplate = {
  clinicalText: "",
  references: [],
  comments: [],
  imgFile: [],
  isValidated: false,
  needReview: false,
  inEnglish: false,
  // idEmployee: "607ce10055140023930710de",
  idQuestions: []
}

export const answerTemplate = {
  // "editionsDates": [],
  typeAnswer: 1,
  answerText: "",
  imgFile: [],
  isCorrect: false,
  // "idSpeciality": "60243e1437dc822558beedc0",
  // "idSubSpeciality": "aaab26fbbbcecb389cd506d1"
}

export const questionTemplate = {
  // dateCreated
  idAnswers: [answerTemplate],
  imgFile: [],
  inEnglish: false,
  justification: "",
  textQuestion: "",
  typeQuestion: 1,
  // _id
  // rightAnswer
}